import type { IOptions } from "sanitize-html";
import sanitizeHtml from "sanitize-html";

/** Allowlist aligned with @mixitone/components `Editor` (react-simple-wysiwyg) output. */
const CLUB_MESSAGE_ALLOWED_TAGS = [
  "p",
  "br",
  "div",
  "span",
  "a",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "ul",
  "ol",
  "li",
] as const;

export const sanitizeClubMessageHtmlOptions: IOptions = {
  allowedTags: [...CLUB_MESSAGE_ALLOWED_TAGS],
  allowedAttributes: {
    a: ["href", "name", "target", "rel"],
  },
  allowedSchemes: ["http", "https", "mailto", "tel"],
  allowedSchemesByTag: {
    a: ["http", "https", "mailto", "tel"],
  },
};

/** Sanitize club message HTML for storage and display (XSS-safe subset). */
export function sanitizeClubMessageHtml(html: string): string {
  return sanitizeHtml(html ?? "", sanitizeClubMessageHtmlOptions);
}

function decodeBasicHtmlEntities(text: string): string {
  return text
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#(\d+);/g, (_, code: string) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex: string) => String.fromCharCode(Number.parseInt(hex, 16)));
}

/** Plain text for previews, moderation comparison metadata, and AI scanning. */
export function clubMessageHtmlToPlainText(html: string): string {
  const sanitized = sanitizeClubMessageHtml(html);
  const withoutTags = sanitized.replace(/<[^>]+>/g, " ");
  return decodeBasicHtmlEntities(withoutTags).replace(/\s+/g, " ").trim();
}

export function isClubMessageBodyEmpty(html: string): boolean {
  return clubMessageHtmlToPlainText(html).length === 0;
}
